import React from "react"
import styles from "./styles.css"

export const withHalfHeightOverflow = (Component) => {
  const WrapperComponent = (props) => {
    return (
      <div className={styles.halfSizeWithOverflow}>
        <Component {...props} />
      </div>
    )
  }

  WrapperComponent.displayName = `withHeightOverflow(${Component.displayName})`

  return WrapperComponent
}



// WEBPACK FOOTER //
// ./src/hocs/withHalfHeightOverflow/index.js